<template>
    <div id="header" class="header">
      <div class="building-head-nav" v-if="mobileNavigation">
        <div id="nav-mobile-standard" class="menu-mobile" @click="toggleNav()">
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>
      </div>
      <div class="header__nav" v-if="!mobileNavigation" @click="showInquiries = false">
          <div class="header__nav__item">
              <span class="header__nav__item--link" @click="goToPage('building')">Building</span>
              <span class="header__nav__item--link" @click="goToPage('neighborhood')">Neighborhood</span>
          </div>
          <div class="header__nav__item">
              <span class="header__nav__item--link" @click="goToPage('residences')">Residences</span>
              <span class="header__nav__item--link" @click="goToPage('penthouse')">Penthouses</span>
          </div>
          <div class="header__nav__item">
              <span class="header__nav__item--link" @click="goToPage('team')">Team</span>
              <span class="header__nav__item--link" @click="goToPage('availability')">Availability</span>
          </div>
          <div class="header__nav__item">
              <span class="header__nav__item--link" @click="goToPage('press')">Press</span>
              <span class="header__nav__item--link"  @click="toggleInquiries($event)">Inquiries</span>
          </div>
<!--          <div class="header__nav__item">-->
<!--              <span class="header__nav__item&#45;&#45;link"  @click="toggleInquiries($event)">Inquiries</span>-->
<!--          </div>-->

      </div>
      <div class="header__logo">
        <router-link tag="span" :style= "[showInquiries ? {pointerEvents: 'none'} : null]" :to="{name: 'building'}" exact>
          <img class="header__logo--image" src="../assets/logo-color.svg" alt="Logo">
        </router-link>
      </div>
    </div>
</template>

<script>
    export default {
      name: "Header",
      data: () => ({
        showInquiries: false,
        mobileNavigation: false,
        leftNavigation: false
      }),
      props: {
        inquiries: {
          type: Boolean,
          default: false,
          required: false
        },
      },
      watch: {
        inquiries() {
          this.showInquiries = this.inquiries
        }
      },
      methods: {
        toggleInquiries(event) {
          this.showInquiries = !this.showInquiries
          this.$bus.emit('showInquiries', this.showInquiries);
          this.$bus.emit('showInquiriesOpen', this.showInquiries);
          event.stopPropagation()
        },
        checkMobile() {
          const screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
          if(screenWidth < 600) {
            this.mobileNavigation = true
          }
        },
        toggleNav() {
          this.leftNavigation = !this.leftNavigation
          const element = document.getElementById("nav-mobile-standard");
          element.classList.toggle("change");
          this.$bus.emit('leftNavigation', this.leftNavigation);
        },
          goToPage(value) {
              if (this.showInquiries) {
                  this.toggleInquiries()
                  return
              }
              this.$router.push({
                  name: value
              })
          }
      },
      created() {
        this.checkMobile()
          this.$bus.on('leftNavigationInside', () => {
              this.toggleNav()
          })
      }
    }
</script>

<style scoped>

</style>
